/*
  nb. don't use this if you intend to conditionally
  import a node module server-side (tree-shaking won't work) -
  instead use "typeof window !== 'undefined'" directly
*/
export const isBrowser = typeof window !== 'undefined'
export const isServer = !isBrowser
export const isLambda = isServer && Boolean(process.env.LAMBDA_TASK_ROOT)
export const isDevServer = isServer && !isLambda
